export const merchantMessagesMutations = {
  setMerchantMessages(state, payload) {
    state.merchantMessages = payload;
  },
  setShowThread(state, payload) {
    state.showThread = payload;
  }, 
  setShowConv(state, payload) {
    state.showConv = payload;
  },  
  setFullName(state, payload) {
    state.fullName = payload;
  },
};
